import React from 'react';
import { IconSvgProps } from '@models/common';

const Warning2: React.FC<IconSvgProps> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 20 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M7.03666 1.60221C8.16155 -0.534075 11.2204 -0.534066 12.3453 1.60221L19.0328 14.3083C20.0841 16.3059 18.6358 18.7056 16.3785 18.7057H3.00346C0.746388 18.7053 -0.701844 16.3058 0.349162 14.3083L7.03666 1.60221ZM10.5757 2.53385C10.2007 1.82192 9.18118 1.82193 8.80619 2.53385L2.11869 15.2399C1.76864 15.9056 2.25141 16.7053 3.00346 16.7057H16.3785C17.1308 16.7056 17.6136 15.9057 17.2632 15.2399L10.5757 2.53385ZM9.70072 12.7057C10.253 12.7057 10.7007 13.1534 10.7007 13.7057C10.7006 14.2579 10.2529 14.7057 9.70072 14.7057H9.69096C9.13892 14.7055 8.69109 14.2578 8.69096 13.7057C8.69096 13.1536 9.13884 12.7059 9.69096 12.7057H9.70072ZM9.69096 4.70573C10.2432 4.70573 10.691 5.15344 10.691 5.70573V10.7057C10.6908 11.2579 10.2432 11.7057 9.69096 11.7057C9.13892 11.7055 8.69109 11.2578 8.69096 10.7057V5.70573C8.69096 5.15356 9.13884 4.70592 9.69096 4.70573Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default Warning2;
